import { MouseEvent, useCallback, useState } from 'react';

type ToggleHandlerProps = (boolean | ((prevState: boolean) => boolean) | MouseEvent<HTMLButtonElement>);

type UseToggleReturnValues =  [boolean, (prop?: ToggleHandlerProps) => void];

export const useToggle = (initialState: boolean = false): UseToggleReturnValues => {
  const [toggle, setToggle] = useState(initialState);

  const toggleHandler = useCallback(
    (prop?: ToggleHandlerProps) => {
      if (typeof prop === 'function') {
        setToggle(prop(toggle));
      } else {
        setToggle((prevState) => typeof prop === 'boolean' ? prop : !prevState);
      }
    },
    [toggle],
  );

  return [toggle, toggleHandler];
};
